import {
  ChatbotAccessRightRequest,
  CirclesInviteTokenInfo,
  SetPasswordTokenData,
  SupportAccessRightRequest,
} from '../../common/types';
import {
  ApiChatbotAccessRightRequest,
  ApiCirclesInviteTokenInfo,
  ApiSetPasswordTokenData,
  ApiSupportAccessRightRequest,
} from '../types';

export function toSetPasswordTokenData({
  email,
  pp_version,
  password_policy,
  token_expired,
  token_used,
  tos_version,
}: ApiSetPasswordTokenData): SetPasswordTokenData {
  return {
    email,
    tokenExpired: token_expired,
    tokenUsed: !!token_used,
    passwordPolicy: password_policy,
    privacyPolicyVersion: pp_version,
    termsOfServiceVersion: tos_version,
  };
}

export function toSupportAccessRightRequest({
  email,
  requester_email,
  token_expired,
  state,
  consent_text,
}: ApiSupportAccessRightRequest): SupportAccessRightRequest {
  return {
    email,
    requesterEmail: requester_email,
    tokenExpired: token_expired,
    state,
    consentText: consent_text,
  };
}

export function toChatbotAccessRightRequest({
  token_expired,
  state,
}: ApiChatbotAccessRightRequest): ChatbotAccessRightRequest {
  return {
    tokenExpired: token_expired,
    state,
  };
}

export function toCirclesInviteTokenInfo({
  invite: { status },
  raf_url,
}: ApiCirclesInviteTokenInfo): CirclesInviteTokenInfo {
  return {
    status,
    rafURL: raf_url,
  };
}
